import React from 'react';
import { motion } from 'framer-motion';
import { LeafIcon } from 'lucide-react';
export function SolutionSection() {
  const highlights = ['Alimentación simple', 'Hábitos realistas', 'Enfoque natural', 'Fácil de aplicar en la rutina diaria'];
  return <section className="py-12 bg-[#EDE4D6]/50 backdrop-blur-[2px]" data-id="element-205">
      <div className="container mx-auto px-6 max-w-3xl text-center" data-id="element-206">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-207">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-black mb-4" data-id="element-208">
            Una guía creada para ayudarte a empezar con pequeños cambios
          </h2>
          <p className="text-base text-black/80 font-semibold mb-6 max-w-xl mx-auto" data-id="element-209">
            Este ebook te muestra un plan claro de 14 días con hábitos sencillos
            y prácticos para ayudarte a sentirte mejor sin complicarte.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-210">
          {highlights.map((item, index) => <motion.div key={index} className="flex items-center justify-center sm:justify-start bg-white rounded-lg p-3 shadow-sm border border-beige-light" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-211">
              <LeafIcon className="w-4 h-4 text-emerald-500 mr-2 flex-shrink-0" data-id="element-212" />
              <span className="font-medium text-text-dark text-sm" data-id="element-213">{item}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}